import styles from "./InspectionDefects.module.css";
import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PortalState } from "../../types/PortalState";
import { getInspectionById, updateDefectImageAssignment } from "../../store/actions/Inspections";
import { MainFrameContext } from "../contexts/MainFrameContext";
import MainFrameContextType from "../../types/MainFrameContextType";
import ElementsContextType from "../../types/ElementsContextType";
import { ElementsContext } from "../contexts/ElementsContext";
import { Page } from "@shopify/polaris";
import { DefectItem } from "../../types/DefectItem";
import InspectionElement from "../../types/InspectionElement";
import DefectItemCard from "../ArtifactElementCard/DefectItemCard";
import { DefectImage } from "../../types/DefectImage";

interface Props {
    id: string;
}

export default function InspectionDefects({ id }: Props) {
    const { setShowSideBar, anchor } = useContext(
        MainFrameContext
    ) as MainFrameContextType;
    const {
        setElements,
        setShowImageViewer,
        setShowGallery,
        setInspection
    } = useContext(ElementsContext) as ElementsContextType;

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const activeInspection = useSelector(
        (state: PortalState) => state.portal.activeInspection
    );

    useEffect(() => {
        dispatch(getInspectionById(id));
        setShowSideBar(true);
    }, []);

    useEffect(() => {
        if (!activeInspection) {
            return;
        }

        setInspection(activeInspection);
        const imageElements = activeInspection.sections.filter(
            (element: any) => {
                return element.ElementType === 2;
            }
        );
        setElements(imageElements);
        setLoading(false);
    }, [activeInspection]);

    useEffect(() => {
        if (anchor === "#landing") {
            setShowGallery(false);
            setShowImageViewer(false);
        }
    }, [anchor]);

    const assignImagesToDefect = (defect: DefectItem, selectedImages: DefectImage[]) => {
        if (!activeInspection) {
            console.error("No active inspection found");
            return;
        }
        
        const defectElementId = activeInspection?.sections.find((element: InspectionElement) => element.Name === "Defects")?.Id;
        if (!defectElementId) {
            console.error("Defect element ID not found");
            return;
        }

        dispatch(updateDefectImageAssignment(activeInspection.Id, defect, selectedImages, defectElementId));
    }

    if (!activeInspection?.defects?.length) {
        return (
            <Page fullWidth>
                <div className={styles.pageHeaderNoGap}>
                    <h1>Inspection Defects</h1>
                </div>
                <p>No defects found for this inspection.</p>
            </Page>
        );
    }

    const defectElement: InspectionElement | undefined = activeInspection?.sections.find((element: InspectionElement) => element.Name === "Defects");

    return (
        <>
            <div>
                <Page fullWidth>
                    <div className={styles.pageHeaderNoGap}>
                        <h1 className={styles.title}>Inspection Defects</h1>
                    </div>
                </Page>
            </div>
            <div>
                {activeInspection?.defects.map((defect: DefectItem) => {
                    return (
                        <div key={defect.defectId} className={styles.defectItemCard}>
                            <DefectItemCard
                                defect={defect}
                                defectsElement={defectElement}
                                assignImagesToDefect={assignImagesToDefect}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
}